<script setup lang="ts">
import {
  ValidationErrorResponse,
  type ApiResponseErrors,
} from 'ui/util/api/ApiResponse';

const props = defineProps<{
  error: NonNullable<ApiResponseErrors>,
}>();

const validationErrors = computed(() => (
  props.error instanceof ValidationErrorResponse
    ? props.error.error.errors
    : undefined
));

const validationMessages = computed(() => {
  if (!validationErrors.value) {
    return [];
  }
  return Object.values(validationErrors.value).flat();
});
</script>

<template>
  <UAlert
    title=""
    color="error"
    variant="subtle"
    role="alert"
    data-cy="cy-error-api"
  >
    <template #leading>
      <UiFaIcon
        :icon="['fal', 'circle-exclamation']"
        class="pt-0.5"
        aria-hidden="true"
      />
    </template>
    <template #title>
      <template v-if="'cancel' in error">
        Request cancelled
      </template>
      <template v-else-if="validationMessages.length === 1">
        Please review the error
      </template>
      <template v-else-if="validationMessages.length">
        Please review the errors
      </template>
      <template v-else>
        {{ error.error.error_message }}
      </template>
    </template>
    <template
      v-if="validationErrors && validationMessages.length"
      #description
    >
      <UiErrorValidation :errors="validationErrors" />
    </template>
  </UAlert>
</template>
